import { HttpClient } from '../httpClient';
import FrequenciesResponse from '../responses/frequenciesResponse';

const httpClient = new HttpClient();

export const getFrequencies = async () => {
  return httpClient.get<FrequenciesResponse>({
    url: '/v1/frequencies',
    requiresToken: true,
  });
};
